import { ACTIONS } from '../actions/login';

export default (state = {}, action) => {
  switch (action.type) {
    case ACTIONS.LOGIN_PROGRESS:
      return {
        ...state,
        type: action.type,
      };
    case ACTIONS.LOGIN_SUCCESS:
      return {
        ...state,
        status: action.type,
        response: action.data,
      };
    case ACTIONS.LOGIN_ERROR:
      return {
        ...state,
        status: action.type,
        response: action.err,
      };
    case ACTIONS.GET_ROLE_SUCCESS:
      return {
        ...state,
        status: action.type,
        responseRole: action.data,
      };
    case ACTIONS.GET_ROLE_ERROR:
      return {
        ...state,
        status: action.type,
        responseRole: action.err,
      };
    default:
      return state;
  }
};
